import { render, staticRenderFns } from "./assignee-task.vue?vue&type=template&id=7c35d299&scoped=true"
import script from "./assignee-task.vue?vue&type=script&lang=js"
export * from "./assignee-task.vue?vue&type=script&lang=js"
import style0 from "./assignee-task.vue?vue&type=style&index=0&id=7c35d299&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c35d299",
  null
  
)

export default component.exports